<template>
<div>
  <div class="wrapper">
      <div class="content" v-if="wish && wish.role_name">
                <div>{{wish.role_name}}的愿望是</div>
              <div v-for="item in wishList" :key="item.id">
                  <div>{{item.desire_name}}~</div>
                <div>{{item.remark}}</div>
              </div>
              
        </div>
        <div class="content" v-else-if="wish && !wish.role_name">
              你还没有许愿，快去许愿吧！
        </div>
      <div class="button-wrapper">
          <img src="../../assets/modal/confirm8.png" alt="" class="button"  @click="$emit('wishOwn-towish')" v-if="wish && !wish.desire_name">
          <img src="../../assets/modal/confirm9.png" alt="" :class="{button: true, grey}"  @click="handleConfirm" v-else-if="wishList && wishList.length">
          <!-- <img src="../../assets/modal/confirm3.png" alt="" class="button"  @click="$emit('wishComplete-reselect')"> -->
      </div>
      
  </div>
</div>
</template>

<script>
import * as api from '@/api/index'
export default {
    name: 'wishOwn',
    props: ["wishData", "wishCount", "myWish"],
    data() {
        return {
            wish: null,
            wishList: null
        }
    },
    mounted() {
        this.getmyWish()
    },
    computed: {
        grey() {
            return this.myWish.length > 1 || (this.myWish.length == 1 && this.wishCount > 0)
        }
    },
    methods: {
       async getmyWish() {
            const res = await api.myWish({
                    activity_id: this.wishData.activity_id
                })
                .catch(err => {

                })
            console.log(res)
            this.wishList = res
            this.wish = res[res.length - 1] || {}
       },
       handleConfirm() {
           if (this.grey) return
            this.$emit('wishOwn-confirm')
       }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 91.76vw;
    margin: 0 auto;
    margin-top: 12vw;
    min-height: 61.11vw;
    background-image: url("../../assets/modal/complete.png");
    background-size: 100% 100%;
    overflow: hidden;
    .content {
        margin: 16vw auto 0;
        width: 66%;
        text-align: center;
        min-height: 24vw;
        font-size: 22px;
        font-weight: bold;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button {
        width: 34.26vw;
        margin: 2vw 2vw;
        display: block;
        flex-shrink: 0;
    }
    .grey {
            filter: grayscale(10);
            border-radius: 4vw;
        }
}

</style>